import React from "react";
import { keyframes, styled } from "@stitches/react";

const DotsLoader = () => (
  <LoadingDots>
    <LoadingDot></LoadingDot>
    <LoadingDot></LoadingDot>
    <LoadingDot></LoadingDot>
  </LoadingDots>
);

const dotsKeyframes = keyframes({
  "0%": { transform: "scale(1, 1)", opacity: 0.4 },
  "50%": { transform: "scale(1.2, 1.2)", opacity: 1 },
  "100%": { transform: "scale(1, 1)", opacity: 0.4 },
});

export default DotsLoader;

const LoadingDots = styled("div", {
  textAlign: "center",
  width: "100%",
});

const LoadingDot = styled("div", {
  animation: `${dotsKeyframes} 1.5s infinite ease-in-out`,
  backgroundColor: "$natematPrimary",
  borderRadius: "5px",
  display: "inline-block",
  height: "5px",
  width: "5px",
  margin: '0 1px',
  "&:nth-child(2)": {
    animationDelay: ".5s",
  },

  "&:nth-child(3)": {
    animationDelay: "1s",
  },
});
